// The org's Knowledge Base documents, cached per group, so Details shows them
// at once when it opens again (and while they are read again).

import { fetchOrgDocuments } from '../../aimd-v2/api';
import type { DocumentItem } from '../../aimd-v2/types';

export const docsCache = new Map<string, DocumentItem[]>();
const docsInFlight = new Map<string, Promise<DocumentItem[]>>();

export const prefetchKnowledge = (groupId?: string | null): Promise<DocumentItem[]> => {
  if (!groupId) return Promise.resolve([]);
  const inflight = docsInFlight.get(groupId);
  if (inflight) return inflight;
  const p = fetchOrgDocuments(groupId)
    .then((d) => {
      docsCache.set(groupId, d);
      return d;
    })
    .catch(() => docsCache.get(groupId) ?? [])
    .finally(() => docsInFlight.delete(groupId));
  docsInFlight.set(groupId, p);
  return p;
};
